module.exports = "query Accounts ($page: Int = 1, $limit: Int = 99999, $asc: String = \"name\", $save_users_email: Boolean = true, $status: String = \"active\") {\n  accounts (page: $page, limit: $limit, asc: $asc, save_users_email: $save_users_email, status: $status) {\n    data {\n      id\n      name\n    }\n    current_page\n    from\n    to\n    per_page\n    total\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/AccountsWithEmailPermission.graphql
// module id = ld1N
// module chunks = 1624